import {lazyComponent} from 'coreUtils/adapters/lazy';

const MinicartFlyout = lazyComponent(() => import('./MinicartFlyout'));

export {MinicartFlyout as default};
